import styled from "styled-components";

export const TopUpCreditsContainer = styled.section`
  margin-top: 37px;
  padding: 15px 38px 15px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bookingOverview.topUpCreditsContainerBgColor};
  max-width: 300px;
`;

export const TopUpCreditsText = styled.div`
  color: ${({ theme }) => theme.colors.bookingOverview.topUpCreditsTextColor};
  font-size: 14px;
  line-height: 19px;
`;

export const TopUpCreditsLearnMore = styled.button`
  color: ${({ theme }) => theme.colors.bookingOverview.topUpCreditsTextColor};
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  margin-left: 4px;
  cursor: pointer;

  transition: transform 0.2s ease-in-out;
  :hover {
    transform: scale(1.03);
  }

  // Remove default button styles
  background: none;
  border: none;
  padding: 0;
  -webkit-appearance: none;
  appearance: none;
`;

export const TopUpCreditsButton = styled.button`
  cursor: pointer;
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: ${({ theme }) => `1px solid ${theme.colors.bookingOverview.topUpCreditsTextColor}`};
  color: ${({ theme }) => theme.colors.bookingOverview.topUpCreditsTextColor};
  transition: all 0.2s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.colors.bookingOverview.topUpCreditsButtonHoveredBgColor};
    color: ${({ theme }) => theme.colors.bookingOverview.topUpCreditsButtonHoveredTextColor};
  }
`;
